import type { Dayjs } from "dayjs";

import { DATE_RANGE } from "./Constants";
import { getAdminNow } from "./dateService";

export type DayjsRange = [Dayjs, Dayjs];

// Keep in lockstep with `@media (max-width: 768px)` on ChartCard, DatePicker,
// Header, and KPI chart cards so layout and last-7-days defaults switch together.
export const NARROW_VIEWPORT_MEDIA_QUERY = "(max-width: 768px)";

export const prefersNarrowViewport = (): boolean =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia(NARROW_VIEWPORT_MEDIA_QUERY).matches;

export const last7DaysRange = (): DayjsRange => {
  const now = getAdminNow();
  return [now.subtract(6, "day").startOf("day"), now.endOf("day")];
};

// Snapshot these via `useState(() => …)` so a later resize does not
// overwrite a range the admin already picked.
export const defaultDateRangeForViewport = (
  wideDefault: DayjsRange | (() => DayjsRange),
): DayjsRange =>
  prefersNarrowViewport()
    ? last7DaysRange()
    : typeof wideDefault === "function"
      ? wideDefault()
      : wideDefault;

export const defaultStartRangeForViewport = (widePreset: string): string =>
  prefersNarrowViewport() ? DATE_RANGE.LAST_7_DAYS : widePreset;
